<div class="modal question-modal">
  <div class="p-4 sm:pl-0 sm:pt-0 text-2xl font-semibold">
    {{ title ?? 'Rechner' | translate | interpolate: params }}
  </div>
  <div class="flex flex-nowrap">
    <soft-calculator [input]="value" (submit)="onSubmit($event)"></soft-calculator>
  </div>
</div>
